import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type UpdateRestaurantAdditionalDataResult =
	| { success: true; errors: null }
	| { success: false; errors: MutationHandlerError }

const updateRestaurantAdditionalData = async ({
	slug,
	phone,
	email,
}: {
	slug: string
	phone: string
	email: string
}): Promise<UpdateRestaurantAdditionalDataResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation UpdateRestaurantAdditionalData($slug: String!, $phone: String!, $email: String!) {
					updateRestaurantAdditionalData(slug: $slug, phone: $phone, email: $email) {
						success
						error
						# Apollo übernimmt die neuen Daten per id in jede Anbieterliste.
						providers {
							id
							phone
							email
						}
					}
				}
			`,
			variables: { slug, phone, email },
			errorPolicy: 'all',
		})

		if (errors) return { success: false, errors }
		const result = data?.updateRestaurantAdditionalData
		if (!result?.success) {
			return { success: false, errors: result?.error || 'Speichern fehlgeschlagen' }
		}
		return { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default updateRestaurantAdditionalData
